import { render } from "./OrderPartEditPayment.vue?vue&type=template&id=5603c938&scoped=true"
import script from "./OrderPartEditPayment.vue?vue&type=script&lang=js"
export * from "./OrderPartEditPayment.vue?vue&type=script&lang=js"

import "./OrderPartEditPayment.vue?vue&type=style&index=0&id=5603c938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5603c938"]])

export default __exports__